import Vue from "vue";

export default {
    // general
    getUserInfo: function(state) {
        return state.userInfo;
    },
    getLang: function(state) {
        return state.lang;
    },
    getTranslation: function(state) {
        return function(word) {
            return state.stored_translations.hasOwnProperty(word)
                ? state.stored_translations[word]
                : word;
        };
    },
    getSelect2ContractorsList: function(state) {
        return state.select2ContractorsList;
    },
    getSelect2IdNumbersList: function(state) {
        return state.select2IdNumbersList;
    },
    getServerInfo: function(state) {
        return state.server_info;
    },
    getSelect2DocumentsCurrenciesList: function(state) {
        return state.select2DocumentsCurrenciesList;
    },
    getCountryTranslations: state => countryId => {
        return state.countries_translations[countryId].country_name[state.lang];
    },
    getCountriesSelect2: state => {

        let countries_translations = state.countries_translations;
        let select2List = [{ id: -1, text: "\xa0", eu_country: "0" }];
        for (const country of state.clientForm.countriesSelect) {
            let countryTemp = new Object();
            countryTemp.id = country.id;
            countryTemp.text =
                countries_translations[country.id].country_name[state.lang];
            countryTemp.eu_country = country.eu_country;
            countryTemp.is_trashed = country.deleted_at !== null
            select2List.push(countryTemp);
        }
        return select2List;
    },
    getOperationParentOrSelf(state) {
        return operation => {
            if(!['', null, undefined].includes(operation.payment_source) && operation.payment_source.payment_type_name === 'department_transfers') return operation
            if(!['', null, undefined].includes(operation.parent)) return operation.parent
            return operation;
        }
    },
    getOperationRootOrSelf(state) {
        return operation => {
            if(!['', null, undefined].includes(operation.operation_root)) return operation.operation_root
            return operation;
        }
    },
};
